(function () {
    'use strict';

    angular.module("imApp").factory("stockPlaceDelTimesService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockPlaceDelTimes: function (parms) {
                return $ihttp.post({
                    method: 801,
                    parameters: parms || {}
                });
            },
            listStockPlaceDelTimes: function (parms) {
                return $ihttp.post({
                    method: 782,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
